import {
  useSortValueFromUrl,
} from 'idsk-react-components';
import { SortDirectionEnum } from 'tezaury-frontend-ts-axios';
import { useParams } from 'react-router';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import TerminListPage from '../../../../../model/TerminListPage';
import { fetchTerminPage } from '../../../../../client/termin/terminListClient';
import { TerminListAdminFilter } from '../../../../../model/TerminListAdminFilter';

interface ReturnType {
  terminPage: TerminListPage;
  terminListStatus: ClientStatus;
  pageNumber: number;
  reloadTerminList;
}

const getSortByEnum = (sortDirection): SortDirectionEnum => (sortDirection === 'asc'
  ? SortDirectionEnum.Asc : SortDirectionEnum.Desc);

export default (
  filter: TerminListAdminFilter,
  page: number,
  perPage: number,
): ReturnType => {
  const { sort } = useSortValueFromUrl();
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();

  const {
    data: terminPage,
    status: terminListStatus,
    refetch: reloadTerminList,
  } = useClientFetch(
    fetchTerminPage,
    [tezaurusUuid,
      filter.hladanyTermin,
      filter.publikovany,
      filter.autorPoslednejZmeny?.uuid,
      page,
      perPage,
      sort[0] ? sort[0] : 'preferovanyTerminSort',
      sort[1] ? getSortByEnum(sort[1]) : SortDirectionEnum.Asc],
    [JSON.stringify(filter), page, perPage, sort[0], sort[1]],
  );

  return <ReturnType>{
    terminPage,
    terminListStatus,
    pageNumber: page,
    reloadTerminList,
  };
};
